import React from 'react';

import PropTypes from 'prop-types';
import {
    Box,
    Grid,
    LinearProgress,
    LinearProgressProps,
    withStyles,
} from '@material-ui/core';

import {Utils} from 'commons';
import {InferPropTypes} from 'commons/types/Types';
import LinearProgressStyles from 'assets/tss/layouts/components/linear-progress/LinearProgressStyles';

EfeLinearProgress.propTypes = {
    totalSteps: PropTypes.number.isRequired,
    currentStep: PropTypes.number.isRequired,
};

function EfeLinearProgress(
    props: InferPropTypes<
        typeof EfeLinearProgress.propTypes & LinearProgressProps,
        typeof LinearProgressStyles
    >
) {
    const {totalSteps, currentStep, classes, ...other} = props;

    return (
        <div className='EfeLinearProgress'>
            <Grid
                container
                direction={'row'}
                key={Utils.functions.Generate.uniqueID('EfeLinearProgress')}>
                <Grid item xs={12} sm={12} md={12}>
                    <LinearProgress
                        color='primary'
                        classes={classes}
                        variant='determinate'
                        value={(currentStep * 100) / totalSteps}
                        {...other}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <Box pt={1}>{`${currentStep}/${totalSteps}`}</Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default withStyles(LinearProgressStyles)(EfeLinearProgress);
